import React from 'react';
import { Route } from 'react-router-dom';

export const getAvailableRoutes = (routesArr, routesPathsArr) => (routesArr?.length ? routesArr
  .filter(({ link, condition }) => {
    if (routesPathsArr && routesPathsArr.indexOf(link) !== -1) {
      return condition ?? true;
    }
    return false;
  }) : []);

export const generateDomRoutes = (routesArr) => (routesArr?.length ? routesArr.map(({
  key, title, link, component, exact,
}) => <Route key={`${key}@${title}`} path={link} exact={exact || false}>{component}</Route>) : []);

export const generateRoutes = (routesArr, routesPathsArr) => generateDomRoutes(
  getAvailableRoutes(routesArr, routesPathsArr),
);
